import { render, staticRenderFns } from "./SMoneyInput.vue?vue&type=template&id=6612922c"
import script from "./SMoneyInput.vue?vue&type=script&lang=js"
export * from "./SMoneyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports